<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg4>          
            <v-card pa-0>              
              <v-divider></v-divider>
              <v-card-text class="">
                  <v-form v-model="valid">
                      <v-autocomplete
                          :disabled="!isEditing"
                          :items="kecamatan"
                          :filter="customFilter"                                
                          item-text="nama"
                          item-value="id"
                          v-model="formModel.kecamatan_id"
                          label="Kecamatan"
                      ></v-autocomplete>      

                      <v-text-field
                          label="Name"
                          name="nama"                              
                          v-model="formModel.nama"
                          v-validate="'required'"
                          data-vv-name="nama"     
                          :error-messages="errors.collect('nama')"  
                          required
                      ></v-text-field>

                      <v-text-field
                          label="Kode Pos"
                          name="kode_pos"                              
                          v-model="formModel.kode_pos"
                          v-validate="'required'"
                          data-vv-name="kode_Pos"     
                          :error-messages="errors.collect('kode_pos')"  
                          required
                      ></v-text-field>
                                
                            
                      <div class="form-btn">
                          <v-btn v-if="!isUpdate" @click="save(isUpdate)" color="success">Create</v-btn>
                          <v-btn v-else @click="save(isUpdate)" color="primary">Update</v-btn>                                                                                              
                      </div>  
                        
                  </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import kelurahan   from '@/apps/admin/models/Kelurahan';    
import moment from 'moment';

var model = new kelurahan();

export default {
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        isEditing:true,
        isUpdate:false,
        
        nama:null,
        kecamatan:[],
        formModel: {
                    
          nama    : null,
          kecamatan_id : null
        },
        //countries: Countries,
        balance: [],    
        valid: true
    }),
    created () {this.getKecamatan()},    
    mounted () {this.init();}, 
    methods : {
        init(){
            if(this.$route.query.id){
                this.isUpdate  = true;
                model.one({id : this.$route.query.id }).then(data => {                      
                    Object.assign(this.formModel, data === null ? {}:data);                                  
                    this.checking(data);
                });                                               
            }
            
            this.$validator.localize('en', this.dictionary);       
        },
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = moment().valueOf();
            this.formModel.info = null;
            if( !this.errors.any() ) {
                var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){   
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },
    
        customFilter (item, queryText, itemText) {
            const textOne = item.nama.toLowerCase()
            //const textTwo = item.abbr.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1; 
        },    
        
        getKecamatan(){
            model.getKecamatan().then(data =>{
               this.kecamatan = data; 
            });
        }

       
    }
}
</script>